import request from '@/utils/request'

const lotteryApi = {
  // 扫码
  lotteryScan: (data) => {
    return request({
      url: '/activity/scan-lottery/scan',
      method: 'post',
      disableError: true,
      data
    })
  },
  // 查询所有卡券
  getCouponList: (params) => {
    return request({
      url: '/activity/scan-lottery/list',
      method: 'get',
      params
    })
  },
  // 查询卡券数量
  getCouponCount: () => {
    return request({
      url: '/activity/scan-lottery/count',
      method: 'get'
    })
  }
}

export default lotteryApi
